document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.querySelector('.js-menu-opener')
  const menu = document.querySelector('.js-toggle-menu')
  const roofBox = document.querySelector('.js-roof-box')
  const roofInfo = document.querySelector('.js-roof-info')

  toggleBtn.addEventListener('click', () => {
    menu.classList.toggle('transform-toogle-menu')
    roofBox.classList.toggle('fixed-roof-box')
    roofInfo.classList.toggle('fixed-roof-info')
  })
})
